import { useQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';

import { FETCH_CLIENT_GROUP_NAME } from './clientGroupBreadcrumb.query';

export function ClientGroupBreadcrumb() {
  const { data } = useQuery(FETCH_CLIENT_GROUP_NAME, {
    variables: { id: useParams().clientGroupId },
  });

  return data ? data.fetchClientGroup?.clientGroup.name : 'Client Group';
}
